<template>
  <div class="businesDepartment">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
    ></sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar size="mini" :style="{ display: menuButtonList.length == 0 ? 'none' : 'block' }">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == $t('businesDepartment.businesList.delete') ||
                item.label == $t('businesDepartment.businesList.forbidden')
                  ? '#FE8783'
                  : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == $t('businesDepartment.businesList.delete') ||
                item.label == $t('businesDepartment.businesList.forbidden')
                  ? '#FE8783'
                  : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              class="btn"
              :loading="loadBtn"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        column-key
        :row-id="rowKey"
        resizable
        ref="xTable"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="load"
        :edit-actived="activeIndex"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="validRules"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        :checkbox-config="{ reserve: reserve, checkRowKeys: checkRowKeys }"
        :radio-config="{ checkRowKey: checkRowKeys.join(',') }"
        @cell-click="getActiveIndex"
        @cell-dblclick="dblclickEvent"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-actived="editActivedEvent"
      >
        <vxe-table-column type="checkbox" width="80" fixed="left"></vxe-table-column>
        <vxe-table-column
          type="index"
          :title="$t('currenciesAndCalendar.queryCurrencies.index')"
          width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="companyDepartment"
          :title="$t('businesDepartment.businesList.companyDepartment')"
          :edit-render="{ type: 'default' }"
          width="210"
        >
          <template v-slot:edit="{ row }">
            <el-cascader
              v-model="row.companyDepartment"
              :options="companyDepartmentList"
              @change="handleChange(row)"
              filterable
            ></el-cascader>
          </template>
          <template v-slot="{ row }">
            <p
              >{{ getCascaderLabel(1, row.companyDepartment, companyDepartmentList) }}
              {{ getCascaderLabel(2, row.companyDepartment, companyDepartmentList) }}</p
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="planCycle"
          :title="$t('businesDepartment.businesList.planWeek')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.planCycle"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in planWeekList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.planCycle, planWeekList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="year"
          :title="$t('businesDepartment.businesList.year')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.year"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.year, yearList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="month"
          :title="$t('businesDepartment.businesList.month')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.month"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.month, monthList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planStartDate"
          :title="$t('businesDepartment.businesList.planStartDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-date-picker
              v-model="row.planStartDate"
              type="date"
              format="yyyy/MM/dd"
            ></el-date-picker>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.planStartDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planEndDate"
          :title="$t('businesDepartment.businesList.planEndDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-date-picker
              v-model="row.planEndDate"
              type="date"
              format="yyyy/MM/dd"
            ></el-date-picker>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.planEndDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="productName"
          :title="$t('businesDepartment.businesList.productName')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input
              v-model="scope.row.productName"
              @input="$refs.xTable.updateStatus(scope)"
            ></el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="cashType"
          :title="$t('businesDepartment.businesList.cashType')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.cashType"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in paymentTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.cashType, paymentTypeList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="partnerName"
          :title="$t('businesDepartment.businesList.partnerName')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input
              v-model="scope.row.partnerName"
              @input="$refs.xTable.updateStatus(scope)"
            ></el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('businesDepartment.businesList.quantity')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.quantity"
              :max="999999999.999999"
              :precision="6"
              :clearable="true"
              @input="$refs.xTable.updateStatus(scope)"
            >
            </input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="unitPrice"
          :title="$t('businesDepartment.businesList.unitPrice')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.unitPrice"
              :max="99999999999.999999"
              :precision="6"
              :clearable="true"
              @input="$refs.xTable.updateStatus(scope)"
            >
            </input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="paymentType"
          :title="$t('businesDepartment.businesList.paymentType')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.paymentType"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in payForWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.paymentType, payForWayList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveAmount"
          :title="$t('businesDepartment.businesList.receiveAmount')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.receiveAmount"
              :max="99999999999.999999"
              :precision="6"
              :clearable="true"
              @input="$refs.xTable.updateStatus(scope)"
            >
            </input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payAmount"
          :title="$t('businesDepartment.businesList.payAmount')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.payAmount"
              :max="99999999999.999999"
              :precision="6"
              :clearable="true"
              @input="$refs.xTable.updateStatus(scope)"
            >
            </input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="paymentDate"
          :title="$t('businesDepartment.businesList.paymentDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-date-picker
              v-model="row.paymentDate"
              type="date"
              format="yyyy/MM/dd"
            ></el-date-picker>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.paymentDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="currencyType"
          :title="$t('businesDepartment.businesList.currencyType')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.currencyType"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in currencyList"
                :key="item.id"
                :label="item.currencyName"
                :value="item.currencyCode"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            getSelectLabel(row.currencyType, currencyList, 'currencyCode', 'currencyName')
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="inputPerson"
          :title="$t('businesDepartment.businesList.inputPerson')"
          min-width="140"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="scope">
            <el-input
              v-model="scope.row.inputPerson"
              @input="$refs.xTable.updateStatus(scope)"
              disabled
            ></el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="mark"
          :title="$t('businesDepartment.businesList.mark')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input v-model="scope.row.mark" @input="$refs.xTable.updateStatus(scope)"></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalPlane/businesDepartment';
  import SiruiSearch from '@/components/SiruiSearch';
  import InputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  // import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'businesDepartment',
    components: {
      SiruiSearch,
      InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
      searchColumns() {
        return [
          {
            prop: 'planCompanyCode',
            name: this.$t('businesDepartment.businesList.company'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          //   事业部门
          {
            prop: 'planDepartmentCode',
            name: this.$t('businesDepartment.businesList.department'),
            type: 'select',
            options: this.departmentList,
          },
          // {
          //   prop: "planDepartmentCode",
          //   name: this.$t('businesDepartment.businesList.department'),
          //   type: "treeSelect",
          //   apiUrl:BASEAPI.LIST_COMPANY_API,
          //   apiData: {
          //     tenantCode: this.userInfo.userInfo.tenantCode,
          //     adminFlag: this.userInfo.userInfo.adminFlag
          //   },
          //   multiple:true,
          //   isName: false,
          //   clearable: false
          // },
          {
            prop: 'planCycle',
            name: this.$t('businesDepartment.businesList.planWeek'),
            type: 'select',
            options: this.planWeekList,
          },
          {
            prop: 'planStartDate',
            name: this.$t('businesDepartment.businesList.planStartDate'),
            type: 'date',
          },
          {
            prop: 'planEndDate',
            name: this.$t('businesDepartment.businesList.planEndDate'),
            type: 'date',
          },
          /* {
          prop: "planStartDateStart",
          name: this.$t("businesDepartment.businesList.planStartDateStart"),
          type: "startDaterangePicker"
        },
        {
          prop: "planStartDateEnd",
          name: this.$t("businesDepartment.businesList.planStartDateEnd"),
          type: "endDaterangePicker"
        },
        {
          prop: "planEndDateStart",
          name: this.$t("businesDepartment.businesList.planEndDateStart"),
          type: "startDaterangePicker"
        },
        {
          prop: "planEndDateEnd",
          name: this.$t("businesDepartment.businesList.planEndDateEnd"),
          type: "endDaterangePicker"
        } */
        ];
      },
    },
    data() {
      return {
        validRules: {
          planCompanyCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.companyValidRules')}`,
            },
          ],
          planDepartmentCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.departmentValidRules')}`,
            },
          ],
          year: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.yearValidRules')}`,
            },
          ],
          month: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.monthValidRules')}`,
            },
          ],
          //物料
          productName: [
            {
              min: 0,
              max: 250,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //合作伙伴
          partnerName: [
            {
              min: 0,
              max: 250,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          planCycle: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planCycleValidRules')}`,
            },
          ],
          paymentType: [
            {
              required: true,
              message: `${this.$t('currenciesAndCalendar.rules.paymentType')}`,
            },
          ],
          currencyType: [
            {
              min: 0,
              max: 250,
              message: `${this.$t('businesDepartment.businesList.currencyTypeValidRules')}`,
            },
          ],
          quantity: [
            {
              min: 0,
              max: 20,
              message: `${this.$t('businesDepartment.businesList.quantityValidRules')}`,
            },
          ],
          //单价
          unitPrice: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          receiveAmount: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.receiveAmountValidRules')}`,
            },
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          payAmount: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.payAmountValidRules')}`,
            },
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          mark: [
            {
              min: 0,
              max: 256,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          // currencyType:[
          //   {
          //     required: true,
          //     message: `${this.$t('currenciesAndCalendar.rules.currencyType')}`
          //   }
          // ]
        },
        flag: false,
        rowKey: 'id',
        checkRowKeys: [],
        reserve: true,
        activeIndex: '', // 激活行索引
        menuButtonList: [], // 按钮
        load: false,
        loadBtn: false,
        tableData: [], //表格数据
        multipleSelection: [], //选中行
        columnListDefault: [],
        searchForm: {
          // 搜索条件
          planCompanyCode: null, //公司
          planDepartmentCode: null, //事业部门
          planCycle: null, //计划周期
          planStartDateStart: null, //计划开始日期起
          planStartDateEnd: null, //计划开始日期止
          planEndDateStart: null, //计划结束日期起
          planEndDateEnd: null, //计划结束日期止
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        }, //
        companyList: [], //公司列表
        companyDepartmentList: [], //公司树
        planDepartmentList: [],
        departmentList: [],
        planWeekList: [
          // {value:"1",label:"月计划"},
          // {value:"2",label:"半月计划"},
          // {value:"3",label:"日计划"},
          // {value:"4",label:"自定义计划"},
        ], //计划周期
        monthList: [
          {
            value: '1',
            label: '1' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '2',
            label: '2' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '3',
            label: '3' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '4',
            label: '4' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '5',
            label: '5' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '6',
            label: '6' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '7',
            label: '7' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '8',
            label: '8' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '9',
            label: '9' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '10',
            label: '10' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '11',
            label: '11' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '12',
            label: '12' + this.$t('businesDepartment.businesList.mon'),
          },
        ], //月份
        paymentTypeList: [], //款项类型列表
        payForWayList: [], //收付方式
        currencyList: [], //币别
        yearList: [], //年度
      };
    },
    mounted() {
      this.getButtonList();
      this.getDictionary();
      this.getData();
    },
    methods: {
      //获取table数据
      getData() {
        const params = JSON.parse(JSON.stringify(this.searchForm));
        params.pageSize = this.page.pageSize;
        params.pageNum = this.page.pageNum;
        this.load = true;
        this.$axios.post(API.SELECT_PLAN_BUSINESS_BYPAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.tableData.forEach((item) => {
              item.companyDepartment = [item.planCompanyCode, item.planDepartmentCode];
            });
            this.page.total = res.data.data.total;
          }
        });
      },

      activeRowMethod() {
        //禁用编辑
        return false;
      },
      editActivedEvent(row) {
        this.changeCompany(row);
      },
      // 获取公司部门
      async changeCompany(val) {
        this.searchForm.planDepartmentCode = null;
        let personDepartmentInfo = [];
        if (val) {
          let res = await this.$baseRequest.getDepartment(val.val);
          if (res) {
            this.departmentList = res;
          }

          /* const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName
        };
        this.$axios.post(BASEAPI.GET_PERSON_API, params).then(res => {
          if (res.data.code === 0) {
            personDepartmentInfo = res.data.data.personDepartmentInfo.map(
              item => {
                return {
                  value: item.personDepartmentCode,
                  label: item.personDepartmentName
                };
              }
            );
            if (val.row) {
              if (val.row.planCompanyCode) {
                this.planDepartmentList = personDepartmentInfo;
              }
            } else {
              if (this.searchForm.planCompanyCode) {
                this.departmentList = personDepartmentInfo;
              } else {
                this.departmentList = [];
              }
            }
          }
        }); */
        } else {
          this.planDepartmentList = personDepartmentInfo;
        }
        if (val.row && val.row.planCompanyCode) {
          this.$refs.xTable.updateStatus(val);
        }
      },
      departmentChange(val) {
        val.row.planDepartmentName = this.planDepartmentList.find(
          (item) => item.value === val.row.planDepartmentCode
        ).label;
        this.$refs.xTable.updateStatus(val);
      },
      //创建
      creatFinancing() {
        let val = {
          path: '/capitalPlan/safeguardDepartment',
          name: 'safeguardDepartment',
          title: this.$t('businesDepartment.businesList.toSafeguardDepartment'),
        };
        this.toRouter(val);
      },
      //修改
      reviseFinancing() {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length <= 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('businesDepartment.businesList.selectOnechangeEdit'),
          });
        } else {
          let val = {
            path: '/capitalPlan/safeguardDepartment',
            name: 'safeguardDepartment',
            title: this.$t('businesDepartment.businesList.toSafeguardDepartment'),
          };
          let id = changeList.map((item) => {
            return item.id;
          });
          this.toRouter(val, 1, id);
        }
      },
      //删除
      deletFinancing() {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          this.$confirmAction()
            .then(() => {
              let ids = changeList.map((item) => {
                return item.id;
              });
              let params = {
                idList: ids,
              };
              this.$axios.post(API.DELETE_PLAN_BUSINESS, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: res.data.msg,
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('personnel.table.deletFalse'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('businesDepartment.businesList.pleaseChangeDelete'),
          });
        }
      },
      //校验+保存
      save() {
        if (this.tableData.length <= 0) {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.noSaveMates'),
            type: 'error',
          });
        } else {
          this.flag = true;
          // let formList = ['xTable'];
          let resultArr = [];
          // let _self = this;
          // function validates(formName) {
          //   let result = new Promise((resolve, reject) => {
          //     _self.$refs[formName].validate((valid) => {
          //       valid ? resolve() : reject();
          //     });
          //   });
          //   resultArr.push(result);
          // }
          // formList.forEach((item) => {
          //   validates(item); // 循环校验
          // });
          // this.tableData = this.$refs.xTable.getTableData().fullData;
          return Promise.all(resultArr)
            .then(() => {
              let flag1 = this.tableData.some((item) => {
                return (
                  (item.planCycle == 'CP' || item.planCycle == 'DP') &&
                  !item.paymentDate &&
                  typeof item.paymentDate != 'undefined' &&
                  item.paymentDate != 0
                );
              });
              let flag2 = this.tableData.some((item) => {
                return (item.planCycle == 'MP' || item.planCycle == 'HMP') && item.paymentDate;
              });
              if (flag1) {
                this.$message({
                  showClose: true,
                  message: this.$t('businesDepartment.businesList.planDayHasAdd'),
                  type: 'error',
                });
                this.flag = false;
              } else {
                if (flag2) {
                  this.$message({
                    showClose: true,
                    message: this.$t('businesDepartment.businesList.planMonthHasAdd'),
                    type: 'error',
                  });
                  this.flag = false;
                }
              }
              if (this.flag) {
                const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
                  this.user;
                this.tableData.forEach((item) => {
                  item.tenantCode = tenantCode;
                  item.companyCode = companyCode;
                  item.departmentCode = departmentCode;
                  item.companyName = companyName;
                  item.departmentName = departmentName;
                  item.planCompanyName = this.companyList.find(
                    (res) => res.value === item.planCompanyCode
                  ).label;
                });
                let parames = {
                  businessDepartmentList: JSON.parse(JSON.stringify(this.tableData)),
                };
                this.loadBtn = true;
                this.$axios.post(API.SELECT_PLAN_BUSINESS_INSERT, parames).then((res) => {
                  this.loadBtn = false;
                  if (res.data.code == 0) {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'success',
                    });
                    this.getData();
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
              }
            })
            .catch(() => {});
        }
      },
      //路由跳转
      toRouter(val, show, value) {
        let path = {
          path: val.path,
          name: val.name,
          meta: {
            keepAlive: true,
            title: val.title,
          },
        };
        if (value) {
          path.query = { id: value, isShow: show };
        } else {
          path.query = { isShow: 0 };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //双击事件
      dblclickEvent(value) {
        let val = {
          path: '/capitalPlan/safeguardDepartment',
          name: 'safeguardDepartment',
          title: this.$t('businesDepartment.businesList.toSafeguardDepartment'),
        };
        let ids = [];
        ids.push(value.row.id);
        this.toRouter(val, 0, ids);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          this.creatFinancing();
        } else if (type == 'edit') {
          this.reviseFinancing();
        } else if (type == 'delete') {
          this.deletFinancing();
        } else if (type == 'save') {
          this.save();
        } else if (type == 'import') {
          this.exportPerson();
        }
      },
      //导出功能
      exportPerson() {
        const selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach(item => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.SELECT_PLAN_BUSINESS_EXPORT}?${str}access_token=${this.userInfo.userInfo.access_token}`;
        } else {
          let params = { ...this.searchForm };
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.SELECT_PLAN_BUSINESS_EXPORT}?${params}&access_token=${this.userInfo.userInfo.access_token}`;
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //表格日期回显
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //重置
      resetBtnClick() {
        this.$refs.xTable.clearCheckboxReserve();
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      //查询
      searchBtnClick() {
        this.getData();
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      //获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      handleChange(value) {
        this.tableData.forEach((item) => {
          if (item._XID == value._XID) {
            item.planCompanyCode = value.companyDepartment[0];
            item.planDepartmentCode = value.companyDepartment[1];
            this.companyDepartmentList.forEach((res) => {
              if (res.value == item.planCompanyCode) {
                item.planCompanyName = res.label;
                res.children.forEach((val) => {
                  if (val.value == item.planDepartmentCode) {
                    item.planDepartmentName = val.label;
                  }
                });
              }
            });
          }
        });
      },
      getCascaderLabel(val, value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        if (val == 1) {
          return labels[0];
        } else {
          return labels[1];
        }
      },
      //字典
      getDictionary() {
        this.getYearList();
        this.getCurrencyList();
        this.getPayForList();
        this.getCompany();
        this.getComany();
        this.getFinancingVarietiesList();
        this.getPaymentTypeList();
        this.getPlanWeekList();
      },
      //获取融资品种
      async getFinancingVarietiesList() {
        let params = {
          dictType: 'finance_variety',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.varietiesList = selectStatus.data.data;
        }
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear();
        year = year - 11;
        for (let i = 0; i < 21; i++) {
          year = year + 1;
          let object = { value: `${year}`, label: year };
          this.yearList.push(object);
        }
      },
      //获取币别
      async getCurrencyList() {
        this.currencyList = await this.$baseRequest.getCurrency();
      },
      //获取款项类型列表
      async getPaymentTypeList() {
        let params = {
          dictType: 'capitalPlan_plan_cashType',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.paymentTypeList = selectStatus.data.data;
        }
      },
      //获取收付款方式
      async getPayForList() {
        let params = {
          dictType: 'capitalPlan_plan_paymentType',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.payForWayList = selectStatus.data.data;
        }
      },
      //获取搜索框当前公司
      async getComany() {
        // this.companyList = JSON.parse(this.userInfo.userInfo.companyList);
        // this.companyList.forEach(item => {
        //   item.value = item.personCompanyCode;
        //   item.label = item.personCompanyName;
        // });
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      //获取表格公司
      async getCompany() {
        let parames = {
          belongTenantCode: this.user.tenantCode,
          currentStatus: 0,
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_SERECHCOMPANYTREE, parames);
        if (selectStatus.data.code == 0) {
          this.companyDepartmentList = selectStatus.data.data;
        }
      },
      //获取计划周期
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .businesDepartment .pagination {
    text-align: right;
    margin: 10px 0;
  }
  .businesDepartment .main-content {
    border-radius: 4px;
    padding: 10px;
    background: #fff;
    -webkit-box-shadow: 0px 1px 5px #ddd;
    box-shadow: 0px 1px 5px #ddd;
  }
  .btn {
    height: 30px;
    line-height: 30px;
    min-width: 80px;
    border-radius: 3px;
    font-size: 12px;
  }
</style>
